import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { InspectionAPI } from "@/api/inspection.api";

const api = new InspectionAPI()

const authenticity = (params: any): AxiosObservable<any> => api.authenticity(params)

export default {
  authenticity
}